import { Injectable } from '@angular/core';
import { Profile, User } from 'oidc-client';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private _user: User;

  set user(value: User) {
    this._user = value;
  }

  constructor(private authService: AuthenticationService) { 
    authService.storedUser.then(user => {
      this._user = user;
    });
  }

  isLoggedIn(): boolean {
    return this._user != null && !this._user.expired;
  }

  getClaims(): Profile {
    return this._user.profile;
  }

  getTokenType(): string {
    return this._user.token_type;
  }

  getUserAccessToken(): string {
    return this._user.access_token;
  }
}
